const dataSustainabilityScorecard = [
  {
      "iso": "AT",
      "country": "Austria",
      "indexScore": 82.3,
      "tier": "High",
      "wealth": 122500,
      "population": 109,
      "co2": 0.65
  },
  {
      "iso": "GB",
      "country": "UK",
      "indexScore": 81.7,
      "tier": "High",
      "wealth": 97300,
      "population": 277,
      "co2": 0.46
  },
  {
      "iso": "CH",
      "country": "Switzerland",
      "indexScore": 80.5,
      "tier": "Very high",
      "wealth": 352000,
      "population": 220,
      "co2": 0.40
  },
  {
      "iso": "ES",
      "country": "Spain",
      "indexScore": 80.4,
      "tier": "High",
      "wealth": 60400,
      "population": 95,
      "co2": 0.43
  },
  {
      "iso": "PT",
      "country": "Portugal",
      "indexScore": 80,
      "tier": "High",
      "wealth": 64100,
      "population": 113,
      "co2": 0.38
  },
  {
      "iso": "IT",
      "country": "Italy",
      "indexScore": 78.8,
      "tier": "High",
      "wealth": 72300,
      "population": 200,
      "co2": 0.48
  },
  {
      "iso": "CA",
      "country": "Canada",
      "indexScore": 78.5,
      "tier": "High",
      "wealth": 145300,
      "population": 4,
      "co2": 1.33
  },
  {
      "iso": "NZ",
      "country": "New Zealand",
      "indexScore": 78.4,
      "tier": "High",
      "wealth": 134600,
      "population": 19,
      "co2": 0.61
  },
  {
      "iso": "GR",
      "country": "Greece",
      "indexScore": 78.4,
      "tier": "High",
      "wealth": 58800,
      "population": 83,
      "co2": 0.48
  },
  {
      "iso": "LU",
      "country": "Luxembourg",
      "indexScore": 77.6,
      "tier": "Very high",
      "wealth": 580000,
      "population": 249,
      "co2": 1.21
  }
];
export {dataSustainabilityScorecard};